import FixedWidthLayout from './FixedWidthLayout'

export default FixedWidthLayout
